<template>
    <div>
        <component :variants='variants' v-bind="$attrs" :name="name"
                   :question_number="question_number"
                   class="question-block__variant"
                   v-on="$listeners"
                   :is='question_type'
        />
    </div>
</template>

<script>
import QuestionCheckbox from './question_type/question_checkbox';
import QuestionRadio from './question_type/question_radio';
import QuestionText from './question_type/question_text';
import {mapGetters} from 'vuex';
export default {
  components: {
    checkbox  : QuestionCheckbox,
    radio     : QuestionRadio,
    text_field: QuestionText,
  },
  props: {
    variants: {
      type   : Array,
      default: () => [],
    },
    question_type: {
      type    : String,
      required: true,
    },
    name: {
      type: String,
    },
  },
  computed: {
    ...mapGetters('testing/questions', [
      'question_number',
      'questions',
      'stats',
    ]),
  },
};
</script>
